import { motion, MotionProps } from "framer-motion";
import { forwardRef } from "react";
import {
  Text as RACText,
  TextProps as RACTextProps,
} from "react-aria-components";
import { tv } from "tailwind-variants";

const MotionText = motion(RACText);

export interface TextProps extends RACTextProps {
  weight?: "medium" | "semibold" | "regular";
  variant?:
    | "title-large-1"
    | "title-large-2"
    | "title-1"
    | "title-2"
    | "title-3"
    | "title-4"
    | "body-1"
    | "body-2"
    | "body-3"
    | "body-4"
    | "body-5";
}

const text = tv({
  base: "text-black",
  defaultVariants: {
    weight: "regular",
    variant: "body-1",
  },
  variants: {
    weight: {
      medium: "font-medium",
      semibold: "font-semibold",
      regular: "font-regular",
    },
    variant: {
      "title-large-1": "text-5xl leading-15 tracking-tightest",
      "title-large-2": "text-4xl leading-14 tracking-tightest",
      "title-1": "text-3xl leading-13 tracking-normal",
      "title-2": "text-2xl leading-12 tracking-normal",
      "title-3": "text-xl leading-10 tracking-normal",
      "title-4": "text-lg leading-12 tracking-normal",
      "body-1": "text-base leading-12 tracking-normal",
      "body-2": "text-md leading-11 tracking-normal",
      "body-3": "text-sm leading-10 tracking-normal",
      "body-4": "text-xs leading-9 tracking-normal",
      "body-5": "text-2xs leading-8 tracking-normal",
    },
  },
});

const Text = forwardRef<HTMLElement, TextProps & MotionProps>(function Text(
  { weight = "regular", variant = "body-1", className, ...props },
  ref,
) {
  return (
    <MotionText
      {...props}
      ref={ref}
      className={text({ variant, className, weight })}
    />
  );
});

Text.displayName = "Text";

export default Text;
